'use strict'

import Vue from 'vue'
import store from 'CommonApp/store'

// app/auth-guard.js and admin/auth-guard.js were ~90% identical copies
// of the same config-load -> auth-check -> redirect-or-sync shape,
// differing only in how the config loads, the stored entry URL, the
// connect-page redirect params, and whether project/order state gets
// synced from local storage. Shared here so each app only states its
// own differences.
export function createAuthGuard ({ loadConfig, buildEntryUrl, redirectParams, syncProjectState = false }) {
	return function authGuard (to, from, next) {
		console.debug('router before each from', from, 'to', to)

		return loadConfig().then(() => {
			if (to.matched.some(record => record.meta.authRequired)) {
				// this route requires auth, check if logged in
				// if not, redirect to login page.
				Vue.e24.security.requestCurrentUser().then((currentUser) => {
					if (!Vue.e24.security.isAuthenticated()) {
						// Store requested url to use after login or user register
						store.dispatch({
							type: 'updateEntryUrl',
							value: buildEntryUrl(to)
						})

						next({
							name: 'connect',
							params: redirectParams
						})
					} else {
						// Ensure that janux storage service has current username
						Vue.jnx.storageService.setUsername(currentUser.username)

						if (syncProjectState) {
							const activeProject = Vue.jnx.storageService.findItem('activeProject', true)
							store.dispatch({
								type: 'updateActiveProject',
								value: activeProject
							})
							const lastOrder = Vue.jnx.storageService.findItem('lastOrder', true)
							store.dispatch({
								type: 'updateLastOrder',
								value: lastOrder
							})
						}
						next()
					}
				})
			} else {
				next() // make sure to always call next()!
			}
		})
	}
}



// WEBPACK FOOTER //
// ./src/common/auth-guard-factory.js